import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { RequiredDocsUploadComponent } from "../../required-docs-upload.component";
import { DisplayableFile } from "../../../interfaces/displayable-file.interface";
import { SPECIAL_ENROLLMENT_CIRCUMSTANCE_STATE_NAME } from "src/app/angular-elements/form-wrappers/plan-enrollment/individual-plan-enrollment-form/configs/reducers/special-enrollment-circumstance.reducer";
import { SpecialEnrollmentCircumstanceStateStructure } from "src/app/angular-elements/form-wrappers/plan-enrollment/individual-plan-enrollment-form/configs/interfaces/special-enrollment-circumstance.StateStructure.interface";

@Component({
  selector: "app-dynamic-docs-upload-special-enrollment",
  templateUrl: "./dynamic-docs-upload-special-enrollment.component.html",
  styleUrls: [
    "./../../required-docs-upload.component.scss",
    "./dynamic-docs-upload-special-enrollment.component.scss",
  ],
  standalone: false
})
export class DynamicDocsUploadSpecialEnrollmentComponent
  extends RequiredDocsUploadComponent
  implements OnInit, OnDestroy
{
  @Input() customConfigs: {
    formNameValue: string; // Passed along with payload to indicate type of document ( backend uses to organize files )
    minDocuments?: number;
    maxDocuments?: number;
    fifthBullet?: string;
    documentDescription?: string;
    additionalInstructions?: string;
    disableRemoveButtonOnSuccess?: boolean;
  };
  currentDocumentNote: string = '';

  constructor() {
    super();
  }

  async ngOnInit() {
    super.ngOnInit();

    if (this.customConfigs?.documentDescription) {
      this.displayedColumns.splice(1, 0, "Document Description");
    }
  }

  addPayloadAdditions(): (formData: FormData, displayableFileObj: DisplayableFile) => void {
    return (formData: FormData, displayableFileObj: DisplayableFile) => {
      
      // formname
      if (this.customConfigs.formNameValue) {
        formData.append(
          'formname',
          this.customConfigs.formNameValue
        );
      }
      
      // description
      if (this.customConfigs?.documentDescription) {
        formData.append(
          'description',
          displayableFileObj.documentDescription
        )
      }

      // lifeEvent
      const sepData: SpecialEnrollmentCircumstanceStateStructure
        = this.ngRedux.getState().payloadStates[SPECIAL_ENROLLMENT_CIRCUMSTANCE_STATE_NAME];
      if (sepData.lifeEvent?.lifeEventId) {
        formData.append(
          'lifeEvent',
          sepData.lifeEvent.lifeEventId
        )
      }

    }
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
